import React, { useState } from 'react'
import { getIntegrationDetails } from '@demo-system/commons/utilities/integrations'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import { useProject } from 'hooks'

const ExternalWebsiteForm = () => {
  const { project, canEdit, updateProjectPart } = useProject()
  const [integrations, setIntegrations] = useState(project.integrations || {})

  const { orgName, orgId, sandboxName } = getIntegrationDetails(integrations)
  const propertyId = integrations?.launch?.propertyID || integrations?.launch?.propertyId

  const onPropertyIdChange = (propertyID) => {
    setIntegrations((i) => {
      const updated = { ...i, launch: { ...(i.launch || {}), propertyID, propertyId: propertyID } }
      updateProjectPart('integrations', updated)
      return updated
    })
  }

  return (
    <div
      className='ExternalWebsiteForm'
      style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', padding: '1rem' }}
    >
      <FieldLabel label='IMS Organization'>
        <Textfield value={orgName || orgId} disabled={true} style={{ width: '300px' }} />
      </FieldLabel>
      <FieldLabel label='AEP sandbox name'>
        <Textfield value={sandboxName} disabled={true} style={{ width: '300px' }} />
      </FieldLabel>
      <FieldLabel label='Launch Property ID'>
        <Textfield value={propertyId || ''} onChange={onPropertyIdChange} disabled={!canEdit} style={{ width: '300px' }} />
      </FieldLabel>
    </div>
  )
}

export default ExternalWebsiteForm
